var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cell small-6" }, [
    _c("label", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.isActive,
            expression: "isActive",
          },
        ],
        staticClass: "u-no-margin--bottom",
        attrs: { type: "checkbox" },
        domProps: {
          checked: Array.isArray(_vm.isActive)
            ? _vm._i(_vm.isActive, null) > -1
            : _vm.isActive,
        },
        on: {
          change: [
            function ($event) {
              var $$a = _vm.isActive,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.isActive = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.isActive = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.isActive = $$c
              }
            },
            _vm.onActiveChange,
          ],
        },
      }),
      _vm._v(" "),
      _c("i"),
      _vm._v(" "),
      !_vm.hideRanking
        ? _c("span", {
            class: "c-ranking c-ranking--" + (_vm.ranking || "none"),
            attrs: {
              title: _vm.kolonnenNumbersOfOtherWeekAssignments.join(", "),
            },
          })
        : _vm._e(),
      _vm._v("\n    \n      " + _vm._s(_vm.vehicle.displayName) + "\n  \n    "),
      !_vm.hideRanking && _vm.kolonnenNumbersOfOtherWeekAssignments.length
        ? _c(
            "p",
            {
              staticClass:
                "u-no-margin u-text-medium u-text-normal u-text-transform-none",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("kolonne.label.assigned.to.other.kolonnen")) +
                  " " +
                  _vm._s(_vm.kolonnenNumbersOfOtherWeekAssignments.join(", ")) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }